// extracted by mini-css-extract-plugin
module.exports = {"detailPrice__cards":"detail-pricing-cards-module--detail-price__cards--1oHES"};